import { ParsedUrlQuery } from "querystring"
import { buildUrl } from "../../../utils/url"
import { SearchState } from "../types"

interface FilterOption {
  key: string
  values: string[]
}

const getFilters = (searchState: SearchState): FilterOption[] => {
  // if (!searchState.refinementList) {
  //   return []
  // }
  // const filters: FilterOption[] = []
  // for (const filter in searchState.refinementList) {
  //   // if (filter.startsWith("filters.") || filter === "switch") {
  //   //   filters.push({
  //   //     key: filter,
  //   //     values: searchState.refinementList[filter] ?? [],
  //   //   })
  //   // }
  //   if (filter === "brandName") {
  //     filters.push({
  //       key: "brand",
  //       values: searchState.brandNames ?? [],
  //     })
  //   }
  // }
  // return filters
  return []
}

const toFiltersQuery = (filters: FilterOption[]) => {
  const query = {} as any
  for (const filter of filters) {
    if (filter.values.length > 0) {
      query[filter.key] = filter.values
    }
  }

  return query
}

// const forwardParams = [
//   "utm_source",
//   "utm_medium",
//   "includeUnavailable",
//   "showEan",
// ]

// const getForwardParams = (currentParams: ParsedUrlQuery) => {
//   const params = {} as any
//   for (const key of forwardParams) {
//     if (currentParams[key]) {
//       params[key] = currentParams[key]
//     }
//   }
//   return params
// }

const getCategoryCodes = (searchState: SearchState) => searchState.categoryCodes

const getBrandNames = (searchState: SearchState) =>
  (searchState.brandNames ?? []).map((x) => x.split(":")[1])

const getSwitchFilters = (searchState: SearchState) => {
  return Array.from(searchState.switch?.values() ?? [])
}

const getDiscountValues = (searchState: SearchState) =>
  searchState.discountPercentValues

const getTagItems = (searchState: SearchState): string[] => {
  if (!searchState.filters) {
    return []
  }
  const values: string[] = []
  for (const key of searchState.filters.keys()) {
    values.push(
      ...(searchState.filters.get(key)?.map((x) => `${key}:${x}`) ?? [])
    )
  }
  return values
}

export class SerpUrlBuilder {
  createSerpUrl(searchState: SearchState, currentParams: ParsedUrlQuery) {
    const filters = getFilters(searchState)
    const categoryCodes = getCategoryCodes(searchState)
    const brandNames = getBrandNames(searchState)
    const switchFilters = getSwitchFilters(searchState)
    const tagItems = getTagItems(searchState)
    const discountValues = getDiscountValues(searchState)

    return buildUrl("", {
      page: searchState.page,
      orderBy: searchState.orderBy,
      ...toFiltersQuery(filters),
      ...(categoryCodes && categoryCodes.length > 0
        ? {
            category: categoryCodes,
          }
        : {}),
      ...((brandNames?.length ?? 0) > 0
        ? {
            brand: brandNames,
          }
        : {}),
      ...((brandNames?.length ?? 0) > 0
        ? {
            brand: brandNames,
          }
        : {}),
      ...((switchFilters?.length ?? 0) > 0
        ? {
            switch: switchFilters,
          }
        : {}),
      ...((tagItems?.length ?? 0) > 0
        ? {
            tag: tagItems,
          }
        : {}),
      ...((discountValues?.length ?? 0) > 0
        ? {
            discount: discountValues,
          }
        : {}),
      ...(searchState?.price
        ? {
            minPrice: searchState.price.minPrice,
            maxPrice: searchState.price.maxPrice,
          }
        : {}),
    }).replace("?", "#")
  }
}
